export default function sleep(durationInMS = 100, init?: { signal: AbortSignal }): Promise<void> {
  return new Promise((resolve, reject) => {
    init?.signal?.aborted
      ? reject(new Error('Aborted.'))
      : setTimeout(() => {
          init?.signal?.aborted ? reject(new Error('Aborted.')) : resolve();
        }, durationInMS);
  });
}
